export default {
    "address": "0x8692F65Af555EeE1EF0cE49c7bC6703754f10C5b",
    "abi": [{
        "inputs": [{
            "internalType": "address",
            "name": "initialOwner",
            "type": "address"
        }, {"internalType": "contract IVault", "name": "_vault", "type": "address"}],
        "stateMutability": "nonpayable",
        "type": "constructor"
    }, {"inputs": [], "name": "ERC20TransferFailed", "type": "error"}, {
        "inputs": [{
            "internalType": "address",
            "name": "sender",
            "type": "address"
        }, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "internalType": "address",
            "name": "owner",
            "type": "address"
        }], "name": "ERC721IncorrectOwner", "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "operator", "type": "address"}, {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
        }], "name": "ERC721InsufficientApproval", "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "approver", "type": "address"}],
        "name": "ERC721InvalidApprover",
        "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "operator", "type": "address"}],
        "name": "ERC721InvalidOperator",
        "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "owner", "type": "address"}],
        "name": "ERC721InvalidOwner",
        "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "receiver", "type": "address"}],
        "name": "ERC721InvalidReceiver",
        "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "sender", "type": "address"}],
        "name": "ERC721InvalidSender",
        "type": "error"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "ERC721NonexistentToken",
        "type": "error"
    }, {"inputs": [], "name": "InvalidCallback", "type": "error"}, {
        "inputs": [],
        "name": "InvalidCurrency",
        "type": "error"
    }, {"inputs": [], "name": "MismatchedPoolKey", "type": "error"}, {
        "inputs": [],
        "name": "NativeTransferFailed",
        "type": "error"
    }, {"inputs": [], "name": "NotOwner", "type": "error"}, {
        "inputs": [],
        "name": "NotVault",
        "type": "error"
    }, {"inputs": [], "name": "PriceSlippageTooHigh", "type": "error"}, {
        "inputs": [],
        "name": "SafeCastOverflow",
        "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "token", "type": "address"}],
        "name": "SafeERC20FailedOperation",
        "type": "error"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "owner", "type": "address"}, {
            "indexed": true,
            "internalType": "address",
            "name": "approved",
            "type": "address"
        }, {"indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "Approval",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "owner", "type": "address"}, {
            "indexed": true,
            "internalType": "address",
            "name": "operator",
            "type": "address"
        }, {"indexed": false, "internalType": "bool", "name": "approved", "type": "bool"}],
        "name": "ApprovalForAll",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "indexed": true,
            "internalType": "Currency",
            "name": "currency",
            "type": "address"
        }, {"indexed": true, "internalType": "address", "name": "sender", "type": "address"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
        }, {"indexed": false, "internalType": "address", "name": "recipient", "type": "address"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
        }],
        "name": "Deposit",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "user", "type": "address"}, {
            "indexed": true,
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
        }],
        "name": "OwnershipTransferred",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "from", "type": "address"}, {
            "indexed": true,
            "internalType": "address",
            "name": "to",
            "type": "address"
        }, {"indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "Transfer",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "indexed": true,
            "internalType": "Currency",
            "name": "currency",
            "type": "address"
        }, {"indexed": true, "internalType": "address", "name": "sender", "type": "address"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
        }, {"indexed": false, "internalType": "address", "name": "recipient", "type": "address"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
        }],
        "name": "Withdraw",
        "type": "event"
    }, {
        "inputs": [{
            "components": [{
                "internalType": "Currency",
                "name": "currency0",
                "type": "address"
            }, {"internalType": "Currency", "name": "currency1", "type": "address"}, {
                "internalType": "uint24",
                "name": "fee",
                "type": "uint24"
            }, {"internalType": "uint24", "name": "marginFee", "type": "uint24"}],
            "internalType": "struct PoolKey",
            "name": "key",
            "type": "tuple"
        }, {"internalType": "bool", "name": "lendForOne", "type": "bool"}, {
            "internalType": "address",
            "name": "recipient",
            "type": "address"
        }, {"internalType": "uint256", "name": "amount", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
        }],
        "name": "addLending",
        "outputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "stateMutability": "payable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "to", "type": "address"}, {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
        }], "name": "approve", "outputs": [], "stateMutability": "nonpayable", "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "owner", "type": "address"}],
        "name": "balanceOf",
        "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
        "name": "deposit",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    }, {
        "inputs": [{
            "components": [{
                "internalType": "bool",
                "name": "zeroForOne",
                "type": "bool"
            }, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
                "internalType": "uint256",
                "name": "amountIn",
                "type": "uint256"
            }, {"internalType": "uint256", "name": "amountOutMin", "type": "uint256"}, {
                "internalType": "uint256",
                "name": "deadline",
                "type": "uint256"
            }], "internalType": "struct ILendPositionManager.SwapInputParams", "name": "params", "type": "tuple"
        }],
        "name": "exactInput",
        "outputs": [{"internalType": "uint24", "name": "swapFee", "type": "uint24"}, {
            "internalType": "uint256",
            "name": "feeAmount",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "amountOut", "type": "uint256"}],
        "stateMutability": "payable",
        "type": "function"
    }, {
        "inputs": [{
            "components": [{
                "internalType": "bool",
                "name": "zeroForOne",
                "type": "bool"
            }, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
                "internalType": "uint256",
                "name": "amountInMax",
                "type": "uint256"
            }, {"internalType": "uint256", "name": "amountOut", "type": "uint256"}, {
                "internalType": "uint256",
                "name": "deadline",
                "type": "uint256"
            }], "internalType": "struct ILendPositionManager.SwapOutputParams", "name": "params", "type": "tuple"
        }],
        "name": "exactOutput",
        "outputs": [{"internalType": "uint24", "name": "swapFee", "type": "uint24"}, {
            "internalType": "uint256",
            "name": "feeAmount",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "amountIn", "type": "uint256"}],
        "stateMutability": "payable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "getApproved",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "getPositionState",
        "outputs": [{
            "components": [{
                "internalType": "uint128",
                "name": "lendAmount",
                "type": "uint128"
            }, {"internalType": "uint256", "name": "depositCumulativeLast", "type": "uint256"}],
            "internalType": "struct LendPosition.State",
            "name": "position",
            "type": "tuple"
        }],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "owner", "type": "address"}, {
            "internalType": "address",
            "name": "operator",
            "type": "address"
        }],
        "name": "isApprovedForAll",
        "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "lendDirections",
        "outputs": [{"internalType": "bool", "name": "lendForOne", "type": "bool"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [],
        "name": "name",
        "outputs": [{"internalType": "string", "name": "", "type": "string"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [],
        "name": "nextId",
        "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [],
        "name": "owner",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "ownerOf",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "poolIds",
        "outputs": [{"internalType": "PoolId", "name": "poolId", "type": "bytes32"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "PoolId", "name": "poolId", "type": "bytes32"}],
        "name": "poolKeys",
        "outputs": [{"internalType": "Currency", "name": "currency0", "type": "address"}, {
            "internalType": "Currency",
            "name": "currency1",
            "type": "address"
        }, {"internalType": "uint24", "name": "fee", "type": "uint24"}, {
            "internalType": "uint24",
            "name": "marginFee",
            "type": "uint24"
        }],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "from", "type": "address"}, {
            "internalType": "address",
            "name": "to",
            "type": "address"
        }, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "from", "type": "address"}, {
            "internalType": "address",
            "name": "to",
            "type": "address"
        }, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "internalType": "bytes",
            "name": "data",
            "type": "bytes"
        }], "name": "safeTransferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "operator", "type": "address"}, {
            "internalType": "bool",
            "name": "approved",
            "type": "bool"
        }], "name": "setApprovalForAll", "outputs": [], "stateMutability": "nonpayable", "type": "function"
    }, {
        "inputs": [{"internalType": "bytes4", "name": "interfaceId", "type": "bytes4"}],
        "name": "supportsInterface",
        "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [],
        "name": "symbol",
        "outputs": [{"internalType": "string", "name": "", "type": "string"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "tokenURI",
        "outputs": [{"internalType": "string", "name": "", "type": "string"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "from", "type": "address"}, {
            "internalType": "address",
            "name": "to",
            "type": "address"
        }, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "transferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "newOwner", "type": "address"}],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "bytes", "name": "data", "type": "bytes"}],
        "name": "unlockCallback",
        "outputs": [{"internalType": "bytes", "name": "", "type": "bytes"}],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [],
        "name": "vault",
        "outputs": [{"internalType": "contract IVault", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
        "name": "withdraw",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }]
}